import { defineComponent as _defineComponent } from 'vue'
import AdminNavigation from "../../AdminNavigationContainer.vue";
import Loading from "@/components/home/Loading";
import Alert from "@/components/scan/parts/Alert.vue";
import { ref, onMounted } from "vue";
import { useI18n } from "vue3-i18n";
import ResponseData from "@/types/ResponseData";
import UserInfoDataService from "@/services/UserInfoDataService";
import { store } from "@/store/store";


export default /*#__PURE__*/_defineComponent({
  setup(__props, { expose }) {
  expose();

const isLoading = ref(false);
const pageTitle = ref(store.getters.showPageTitle);
const alertMessage = ref("null");
const alertState = ref("neutral");
const i18n = useI18n();
const userId = ref("");
const empNumber = ref("");
const givenName = ref("");
const familyName = ref("");
const email = ref("");
const StationCode = ref("");
const department = ref("");
const title = ref("");
const userIdError = ref("");
const empNumberError = ref("");
const givenNameError = ref("");
const familyNameError = ref("");
const emailError = ref("");
const deptError = ref("");
const titleError = ref("");
const stationError = ref("");
const beforeChangeFName = ref("");
const beforeChangeGName = ref("");

/** 初期表示設定 */
onMounted(function () {
  isLoading.value = false;
});

const backbtnEvt = () => {
  store.dispatch("setShowPage", "DistAdminList");
  store.dispatch("setShowPageTitle", "Company Admin List");
};

// [Add]ボタン押す
const AddProcess = () => {
  alertMessage.value = "null";
  alertState.value = "neutral";

  // フォーマットと空白チェックフラグ
  var screenInputChek = true;
  StationCode.value = StationCode.value.toUpperCase();
  //[User ID]のチェック
  if (userId.value.trim() == "") {
    userIdError.value = i18n.t("alt067");
    screenInputChek = false;
  } else if (!validUserID(userId.value.trim(), true)) {
    userIdError.value = i18n.t("alt068");
    screenInputChek = false;
  } else {
    userIdError.value = "";
  }

  //[Employee Number]のチェック
  if (empNumber.value.trim() == "") {
    empNumberError.value = i18n.t("alt012");
    screenInputChek = false;
  } else if (!validUserID(empNumber.value.trim(), false)) {
    empNumberError.value = i18n.t("alt013");
    screenInputChek = false;
  } else {
    empNumberError.value = "";
  }

  //[Given Name]のチェック
  if (givenName.value.trim() == "") {
    givenNameError.value = i18n.t("alt015");
    screenInputChek = false;
  } else if (checkSpecialCharacter(givenName.value.trim())) {
    givenNameError.value = i18n.t("alt016");
    screenInputChek = false;
  } else {
    givenNameError.value = "";
  }

  //[Family Name]のチェック
  if (familyName.value.trim() == "") {
    familyNameError.value = i18n.t("alt017");
    screenInputChek = false;
  } else if (checkSpecialCharacter(familyName.value.trim())) {
    familyNameError.value = i18n.t("alt018");
    screenInputChek = false;
  } else {
    familyNameError.value = "";
  }

  //[Department]のチェック
  if (department.value) {
    if (checkSpecialCharacter(department.value)) {
      deptError.value = i18n.t("alt019");
      screenInputChek = false;
    } else {
      deptError.value = "";
    }
  }

  //[Title]のチェック
  if (title.value) {
    if (checkSpecialCharacter(title.value)) {
      titleError.value = i18n.t("alt020");
      screenInputChek = false;
    } else {
      titleError.value = "";
    }
  }

  //[E-mail]のチェック
  if (email.value.trim() == "") {
    emailError.value = i18n.t("alt021");
    screenInputChek = false;
  } else if (!validEmail(email.value)) {
    emailError.value = i18n.t("alt022");
    screenInputChek = false;
  } else {
    emailError.value = "";
  }

  //[Station Code]のチェック
  if (StationCode.value.trim() == "") {
    stationError.value = i18n.t("alt023");
    screenInputChek = false;
  } else {
    stationError.value = "";
  }

  // DBデータチェックフラグ
  var dbDataCheckFlg = true;
  // User ID重複チェックを行う
  const data = { userAuthenticateId: userId.value, email: email.value, targetScreen: "DistAdminRegisteration" };
  UserInfoDataService.getUserIDInfo(data)
    .then((response: ResponseData) => {
      if(response.data.message != undefined){
        alert(response.data.message);
        dbDataCheckFlg = false;
      }else if (response.data.length != 0) {
        userIdError.value = i18n.t("alt069");
        dbDataCheckFlg = false;
      }
      // Employee Numberと Station Code重複チェックを行う
      const data = { userId: empNumber.value, stationCode: StationCode.value };
      UserInfoDataService.getEmployeeStationDuplicateInfo(data)
        .then((response: ResponseData) => {
          if (response.data.length != 0 && screenInputChek) {
            alertMessage.value = i18n.t("alt070");
            alertState.value = "error";
            dbDataCheckFlg = false;
          }
          // StationCodeチェックを行う
          const data = {
            stationCode: StationCode.value.trim(),
            companyName: "",
            threeDigit: "",
          };
          UserInfoDataService.getStationInfo(data)
            .then((response: ResponseData) => {
              if (response.data.length == 0 && StationCode.value.trim() != "") {
                stationError.value = i18n.t("alt024");
              } else if (
                response.data.length != 0 &&
                dbDataCheckFlg &&
                screenInputChek
              ) {
                var str3digitCode = "";
                var strCompName = "";
                for (let info2 of response.data) {
                  strCompName = info2.companyName;
                  str3digitCode = info2.digit3_cd;
                }
                // 入力したUserIDの3桁文字コードがステーションコードによる3桁とあっていない場合、
                if (str3digitCode != userId.value.substr(0, 3)) {
                  userIdError.value = i18n.t("alt071");
                } else {
                  // 入力チェックが正しく場合、Admin Userデータ登録を行う
                  const data = {
                    userAuthenticateId: userId.value,
                    employeeNumber: empNumber.value,
                    givenName: givenName.value,
                    familyName: familyName.value,
                    email: email.value,
                    department: department.value,
                    title: title.value,
                    stationCode: StationCode.value,
                  };
                  UserInfoDataService.insertAdminUserInfo(data)
                    .then((response: ResponseData) => {
                      userIdError.value = "";

                      var insertedUser = response.data.adminUser;
                      var oriAdminUserList = store.getters.companyAdminListData;
                      oriAdminUserList.push(insertedUser[0]);
                      oriAdminUserList.sort(function(a: { stationcode: number; givenName: string; }, b: { stationcode: number; givenName: any; }){
                        return a.stationcode - b.stationcode && a.givenName.localeCompare(b.givenName)
                      });
                      store.dispatch("setCompanyAdminListData", oriAdminUserList);
                      // 統合認証ID登録処理
                      insertAuthIDInfo(
                        userId.value,
                        empNumber.value,
                        givenName.value,
                        familyName.value,
                        StationCode.value,
                        strCompName,
                        email.value
                      );
                    })
                    .catch((e: Error) => {
                      alertMessage.value = i18n.t("err016");
                      alertState.value = "error";
                      isLoading.value = false;
                    });
                }
              }
            })
            .catch((e: Error) => {
              alertMessage.value = i18n.t("err018");
              alertState.value = "error";
              isLoading.value = false;
            });
        })
        .catch((e: Error) => {
          alertMessage.value = i18n.t("err020");
          alertState.value = "error";
          isLoading.value = false;
        });
    })
    .catch((e: Error) => {
      alertMessage.value = i18n.t("err020");
      alertState.value = "error";
      isLoading.value = false;
    });
};

const validUserID = (userID, authenticateFlg) => {
  var re1 = /^[A-Za-z0-9]+$/;
  var result = false;
  if (authenticateFlg) {
    result =
      re1.test(userID) &&
      re1.test(userID.substr(0, 3)) &&
      re1.test(userID.substr(3)) &&
      userID.length == 8;
  } else {
    result = re1.test(userID);
  }
  return result;
};
const checkSpecialCharacter = (userName) => {
  var re = /[`!@#$%^&*()_+\-={};':"\\|,.<>/?＿~]/;
  return re.test(userName);
};
const validEmail = (email) => {
  var re =
    /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};

const txtOnKeyDown = (event: { target: { value: any; }; }) => {
  var re = /^[A-Za-z ]+$/;
  beforeChangeFName.value = re.test(familyName.value)? familyName.value: beforeChangeFName.value;
  beforeChangeGName.value = re.test(givenName.value)? givenName.value: beforeChangeGName.value;
}
const checkAlphabet = (event: { target: { value: any; }; }) => {
  var re = /^[A-Za-z ]+$/;
  if(!re.test(event.target.value) && event.target.value != ""){
    familyName.value = beforeChangeFName.value;
    givenName.value = beforeChangeGName.value;
  }
  return;
}

/** 統合認識ID登録処理 */
const insertAuthIDInfo = (
  strAuthID,
  strEmpID,
  strGivenNm,
  strFamilyNm,
  strStationCD,
  strCompName,
  stremail
) => {
  alertMessage.value = "null";
  alertState.value = "neutral";
  const csvfileData1 = {
    actionFlg: 1,
    userID: strAuthID,
    LName: strFamilyNm,
    FName: strGivenNm,
    employeeID: strEmpID,
    mail: stremail,
    companyName: strCompName,
    stationCode: strStationCD,
  };

  UserInfoDataService.send_authenticationID(csvfileData1)
    .then((response: ResponseData) => {
      alertMessage.value = i18n.t("suc032");
      alertState.value = "success";
      isLoading.value = false;
    })
    .catch((e: Error) => {
      alertMessage.value = i18n.t("err063");
      alertState.value = "error";
      isLoading.value = false;
    });
};

const __returned__ = { isLoading, pageTitle, alertMessage, alertState, i18n, userId, empNumber, givenName, familyName, email, StationCode, department, title, userIdError, empNumberError, givenNameError, familyNameError, emailError, deptError, titleError, stationError, beforeChangeFName, beforeChangeGName, backbtnEvt, AddProcess, validUserID, checkSpecialCharacter, validEmail, txtOnKeyDown, checkAlphabet, insertAuthIDInfo, AdminNavigation, Loading, Alert }
Object.defineProperty(__returned__, '__isScriptSetup', { enumerable: false, value: true })
return __returned__
}

})